import type { IconData } from '@stacksjs/iconify-core'

export const pocketWatch: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 13h2a1 1 0 0 1 0 2H8a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0zM7 5.732V5a1 1 0 1 1 2 0v.732a2 2 0 1 0-2 0m-2.041.866a4 4 0 1 1 6.082 0A8.002 8.002 0 0 1 8 22A8 8 0 0 1 4.959 6.598M8 20A6 6 0 1 0 8 8a6 6 0 0 0 0 12\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default pocketWatch
